import { Button, makeStyles } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import KYCDetailsModal from './modals/KYCDetailsModal/KYCDetailsModal';


const KycButton = () => {

    const classes = useStyles()
    const history = useHistory()
    const params = useParams()
    const {id} = params

    const [open, setOpen] = useState(false)

    //console.log(`Cardholder id -> ${id}`)
    

    return ( 
        <div>
            <KYCDetailsModal open={open} onClose={() => setOpen(false)}/>
            <Button className={classes.button} onClick={() => setOpen(true)}>
                KYC
            </Button>
        </div>
        
     );
}

const useStyles = makeStyles(theme => ({
    button:{
        background:indigo[700],
        color:'white',
        '&:hover':{
            background:indigo[900],
        }
    }
}))
 
export default KycButton;